import { render, staticRenderFns } from "./Ability3.vue?vue&type=template&id=ec247558&scoped=true&"
import script from "./Ability3.vue?vue&type=script&lang=js&"
export * from "./Ability3.vue?vue&type=script&lang=js&"
import style0 from "./Ability3.vue?vue&type=style&index=0&id=ec247558&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec247558",
  null
  
)

export default component.exports